export function getFilterLabel(filters, value) {
    return filters.find(filter => filter.value === value).label;
}
